// ** Router imports
import { lazy, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { onMessageListener } from '../init-fcm'
// ** Router imports
import { useRoutes, Navigate } from 'react-router-dom'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout'

// ** Utils
import { getUserData, getHomeRouteForLoggedInUser } from '../utility/Utils'

// ** GetRoutes
import { getRoutes } from './routes'
import { useDispatch } from 'react-redux'
// import { addNew, getData } from '../redux/notification'
import { useRef } from 'react'
import { getNotification } from '../redux/notification'
import { runOneSignal } from '../onesignal'

// ** Components
const Error = lazy(() => import('../views/pages/misc/Error'))
const Login = lazy(() => import('../views/pages/authentication/LoginBasic'))
const NotAuthorized = lazy(() => import('../views/pages/misc/NotAuthorized'))

const Router = () => {
  // ** Hooks
  const { layout } = useLayout()
  const user = getUserData()
  const dispatch = useDispatch()
  const [notification, setNotification] = useState({ title: '', body: '' })
  const [currentPage, setCurrentPage] = useState(1)
  const notify = () =>
    toast(<ToastDisplay />, {
      duration: 6000,
      position: 'top-right',

      // Styling
      style: {},
      className: '',

      // Custom Icon
      // icon: '👏',

      // Change colors of success/error/loading icon
      iconTheme: {
        primary: '#000',
        secondary: '#fff'
      }

      // // Aria
      // ariaProps: {
      //   role: 'status',
      //   'aria-live': 'polite',
      // },
    })
  function ToastDisplay() {
    return (
      <div>
        <p className='mb-0'>
          <b>{notification?.title}</b>
        </p>
        <p className='mb-0'>{notification?.body}</p>
      </div>
    )
  }

  let src = require('../assets/sound.wav').default
  const [playing, setPlaying] = useState(false)
  const audioRef = useRef(new Audio(src))
  useEffect(() => {
    onMessageListener()
      .then(payload => {
        // dispatch(getData())
        setNotification({ title: payload?.notification?.title, body: payload?.notification?.body })
        audioRef.current.play()
        setPlaying(true)
      })
      .catch(err => console.log('failed: ', err))
    if (notification?.title) {
      notify()
    }
    document.body.addEventListener('click', () => (playing ? audioRef.current.pause() : null))
  }, [notification])

  useEffect(() => {
    dispatch(getNotification({ withPaginate: 'no', page: 1, perPage: 15 }))
  }, [dispatch])

  useEffect(() => {
    if (user) runOneSignal()
  }, [])

  const allRoutes = getRoutes(layout)
  const getHomeRoute = () => {
    const user = getUserData()
    if (user) {
      return getHomeRouteForLoggedInUser(user.role)
    } else {
      return '/login'
    }
  }

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <BlankLayout />,
      children: [{ path: '/login', element: <Login /> }]
    },
    {
      path: '/auth/not-auth',
      element: <BlankLayout />,
      children: [{ path: '/auth/not-auth', element: <NotAuthorized /> }]
    },
    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ])

  return routes
}

export default Router
